import { XCircle, CheckCircle } from "lucide-react";

export default function DeleteConfirmationModal({ isOpen, onClose, onConfirm, loading, status, workflowName }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-full max-w-sm bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-lg font-semibold mb-4">Delete Workflow</h2>
        <p className="text-sm text-gray-700 mb-4">
          Are you sure you want to delete <strong>{workflowName}</strong>?
        </p>

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm bg-gray-100 rounded hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="px-4 py-2 text-sm bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-60"
          >
            {loading ? "Deleting..." : "Delete"}
          </button>
        </div>

        {status === "success" && (
          <div className="flex items-center justify-center gap-2 text-green-600 mt-4 animate-pulse">
            <CheckCircle size={20} />
            <span className="text-sm">Workflow deleted</span>
          </div>
        )}

        {status === "error" && (
          <div className="flex items-center justify-center gap-2 text-red-600 mt-4">
            <XCircle size={20} />
            <span className="text-sm">Failed to delete workflow</span>
          </div>
        )}
      </div>
    </div>
  );
}
